/* eslint-disable no-param-reassign */
import { createAsyncThunk } from '@reduxjs/toolkit';

import { syncProductHasVariants } from './helpers/productVariantsHelpers';

export const createVariant = createAsyncThunk(
  'products/createVariant',
  async ({ productId, data }, {
    extra: {
      sdk, Logger, showErrorDialog, utils,
    },
  }) => {
    try {
      const { data: createdVariant } = await sdk.products.createVariant(productId, data);
      return { productId, createdVariant };
    } catch (error) {
      const errorMessage = utils.getDataFromResponceError(error, 'msg') || 'Cannot create product variant';
      showErrorDialog(errorMessage);
      Logger.error(new Error('Error creating product variant'), { error }, [
        'CreateProductVariantFailed',
        { errorMessage: errorMessage || 'NoMessage' },
      ]);
      throw error;
    }
  },
);

export const reducer = (builder) => {
  builder
    .addCase(createVariant.pending, (state, { meta }) => {
      const { productId } = meta.arg;
      state.items.forEach((product) => {
        if (product._id === productId) {
          product.isBusy = true;
        }
      });
    })
    .addCase(createVariant.fulfilled, (state, { payload }) => {
      const { productId, createdVariant } = payload;
      state.items.forEach((product) => {
        if (product._id === productId) {
          product.isBusy = false;
          product.variants = [...(product.variants || []), createdVariant];
          syncProductHasVariants(product);
        }
      });
    })
    .addCase(createVariant.rejected, (state, { meta }) => {
      state.items.forEach((product) => {
        if (product._id === meta.arg.productId) {
          product.isBusy = false;
        }
      });
    });
};
